module.exports = __webpack_public_path__ + "img/ginny-happy.c224cccc.svg";